<!-- BANNER -->
<template>
  <div class="policy_ifno">
    <div class="home_banner fd_column">
      <div class="component_box" style="background: #E0EDFF;">
        <div
          class="banner_bg"
          :style="{ backgroundImage: `url(${$baseImgUrl + bg})` }"
        ></div>
        <!-- 移动端 -->
        <div class="mobile_banner_bg">
          <img :src="$baseImgUrl + bg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getBanner } from "@/api/homebanner";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      swiper: null,
      bg: "",
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async getBanner() {
      let res = await getBanner();
      if (res.code == 1 && res.data) {
        this.bg = res.data.imgUrl;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getBanner();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
// @import url(); 引入公共css类
.component_title {
  margin-bottom: 25.0012px;
}
.policy_ifno {
  position: relative;
  width: 100%;
  margin-top: 0.4479rem;
  .policy_ifno_box {
    justify-content: space-between;
    width: @defaultWidth;
    margin: 0 auto;
  }
  .title {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 19.9988px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #262626;
    line-height: 27px;
    .subtitle {
      margin-top: 7.9987px;
      font-size: 13.9988px;
      font-family: PingFang-SC-Light, PingFang-SC;
      font-weight: 300;
      color: #262626;
      line-height: 27px;
    }
  }
  .content {
    width: 880.0013px;
    justify-content: flex-end;
    flex-wrap: wrap;
    .link_item {
      padding: 7.9987px 15px;
      img {
        width: 13.0013px;
        height: 13.0013px;
        margin-right: 7.9987px;
      }
      font-size: 13.9988px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #666666;
      line-height: 19.0013px;
      border-radius: 4.9988px;

      &:hover {
        background-color: #fff;
        color: @mainColor;
        box-shadow: 0px 3px 16.0013px -7.9987px rgba(101, 101, 101, 0.21);
      }
    }
  }
  .banner_bg {
    width: 100%;
    background-size: 100% 100%;
    height: 1.9063rem;
  }
  .mobile_banner_bg {
    width: 100%;
    // height: 17.5rem;
    margin-top: 1.12rem;
    background-size: 100% 100%;
    img {
      width: 100%;
    }
    .Custom_purchase {
      display: flex;
      align-items: center;
      padding: 0 0.4rem;
      position: absolute;
      bottom: -1.7067rem;
      justify-content: space-between;
      :first-child {
        margin-right: 0.2667rem;
      }
      div {
        width: 4.48rem;
        height: 2.5067rem;
        font-family: Source-Regular;
        font-weight: 400;
        font-size: 0.3467rem;
        text-align: center;
        color: #ffffff;
        background-size: 100% 100%;
        line-height: 2.5067rem;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .banner_bg {
      display: none;
    }
    .banner_content {
      font-size: 0.6667rem;
      position: absolute;
      top: 2.6667rem;
      left: 1.3333rem;
      text-align: center;
      line-height: 1.04rem;
    }
  }
  @media screen and (min-width: 1024px) {
    .mobile_banner_bg {
      display: none;
    }
  }
}

.component_box {
  .normal_flex;
}
.home_banner {
  .policy_list {
    height: 106.0013px;
    border-radius: 10.0012px;
    position: absolute;
    bottom: -73.0012px;
    left: 50%;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 4.0012px 24px 0px rgba(0, 0, 0, 0.1);
    transform: translateX(-50%);
    z-index: 999;
    .normal_flex;
    width: @commentWidth;
    margin: 0 auto;
    &::before {
      content: "";
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10.0012px;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10.0012px);
      opacity: 0.8;
    }
    .dropdown {
      cursor: pointer;
      .dropdown-content {
        /* 隐藏元素 */
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        width: 100%;
        top: 60px;
        padding: 10.0012px 0;
        box-shadow: 0px 7.9987px 16.0013px 0px rgba(0, 0, 0, 0.2);
      }

      .dropdown-content a {
        text-align: center;
        padding: 19.9988px;
        font-size: 16.0013px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #646566;
        line-height: 19.0013px;
        text-decoration: none;
        display: block;
      }

      .dropdown-content a:hover {
        color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
      }

      /* .dropdown的hover效果，作用在.dropdown-content上 */
      &:hover .dropdown-content {
        display: block;
      }
    }
    .policy_item_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 1;
      &:last-child {
        .policy_item_bar {
          border-right: 0;
        }
      }
    }
    .policy_item_bar {
      height: 49.9987px;
      border-right: 1.0012px solid #efefef;
    }
    .policy_item {
      z-index: 1;
      width: 192px;
      height: 49.9987px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      transition: all 0.3s;
      gap: 6px;
      // backdrop-filter: blur(30px); //毛玻璃属性
      // &:hover {
      //   background: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      //   // .title {
      //   //   color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      //   // }
      //   .label {
      //     color: #0c2879;
      //   }
      // }
      &:hover {
        transform: scale(1.1);
      }

      .title_img {
        width: 46.0012px;
        height: 46.0012px;
        object-fit: contain;
      }
      .title {
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #000000;
        line-height: 19.0013px;
        line-height: 34.9988px;
        span {
          margin-left: 9px;
          font-size: 13.9988px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: #0c2879;
          line-height: 19.9988px;
        }
      }
      .label {
        font-size: 13.9988px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #0c2879;
        line-height: 19.9988px;
      }
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
  }
  .component_box {
    width: 100%;
    justify-content: space-between;
    gap: 19.9988px;
    .news_item {
      box-sizing: border-box;
      position: relative;
      background-repeat: no-repeat;
      background-size: 100% auto;
      // background-color: rgb(187, 41, 41);
      box-shadow: 0px 3px 16.0013px -7.9987px rgba(101, 101, 101, 0.21);
      width: 100%;
      height: auto;
      img {
        width: 100%;
        max-height: 600px;
        object-fit: fill;
      }
      .text_box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10.0012px;
        .big_title {
          font-size: 40.0012px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 46.9988px;
        }
        .sub_title {
          font-size: 30px;
          font-family: Source Han Sans SC-Regular, Source Han Sans SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 21px;
        }
      }
      .date {
        font-size: 25.9988px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        // color: #ffffff;
        line-height: 30px;
      }
      .date_year {
        font-size: 16.0013px;
        font-family: Roboto-Light, Roboto;
        font-weight: 300;
        // color: #ffffff;
        line-height: 19.0013px;
      }
      .mask_box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 12px 31.9987px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.1);
        height: 78px;
        width: 100%;
        .title {
          font-size: 16.0013px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 22.9987px;
        }
        .cat {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .cat_item {
            padding: 0 16.9987px;
            background: #ff5048;
            border-radius: 1.9988px;
            font-size: 12px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 27px;
          }
        }
      }
    }
  }
  /*包裹自定义分页器的div的位置等CSS样式*/
}
</style>
<style lang="less">
.home_banner {
  .swiper-horizontal {
    .swiper-control {
      // width: 100%;
      z-index: 99;
      position: absolute;
      bottom: 13.0013px;
      left: 50%;
      transform: translate(-50%, 0);
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .button-prev,
      .button-next {
        cursor: pointer;
        position: relative;
        z-index: 1;
        margin: 0 16.0013px;
      }

      .swiper-pagination-bullets {
        position: relative;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .swiper-pagination-bullet {
          box-sizing: border-box;
          margin: 0 16.0013px !important;
          width: 19.9988px;
          height: 19.9988px;
          background-color: transparent;
          border-radius: 19.9988px;
          border: 1.0012px solid transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 1;
          .customs_inner {
            width: 7.9987px;
            height: 7.9987px;
            display: inline-block;
            background: #020202;
            opacity: 0.5;
            border-radius: 4.0012px;
          }
        }
        .swiper-pagination-bullet-active {
          border: 1.0012px solid #020202;
          .customs_inner {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
